var _style, _g, _defs, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82 50",
    style: {
      enableBackground: "new 0 0 82 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#D8D8D8;stroke-miterlimit:10;}\n\t.st2{clip-path:url(#SVGID_00000129924104927861494720000009406083970487779504_);}\n\t.st3{fill:#004F8B;}\n\t.st4{fill:#ED9F2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,0h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8,0.5h66c4.1,0,7.5,3.4,7.5,7.5v34c0,4.1-3.4,7.5-7.5,7.5H8c-4.1,0-7.5-3.4-7.5-7.5V8C0.5,3.9,3.9,0.5,8,0.5z "
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M8,0h66c4.4,0,8,3.6,8,8v34c0,4.4-3.6,8-8,8H8c-4.4,0-8-3.6-8-8V8C0,3.6,3.6,0,8,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000066507575555137944970000011105805010995906707_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo-2",
    style: {
      clipPath: "url(#SVGID_00000066507575555137944970000011105805010995906707_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(15 17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    className: "st3",
    d: "M18.7,15.8l2.7-15.5h4.3L23,15.8H18.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    className: "st3",
    d: "M38.5,0.7C37.3,0.2,36,0,34.7,0c-4.2,0-7.2,2.1-7.2,5.1c0,2.2,2.1,3.5,3.8,4.2 c1.7,0.8,2.2,1.2,2.2,1.9c0,1-1.3,1.5-2.6,1.5c-1.4,0-2.8-0.2-4-0.8l-0.6-0.2l-0.6,3.5c1.5,0.6,3.1,0.8,4.8,0.8 c4.5,0,7.4-2.1,7.5-5.3c0-1.8-1.1-3.1-3.6-4.2c-1.5-0.7-2.4-1.2-2.4-1.9c0-0.6,0.8-1.3,2.5-1.3c1.1,0,2.2,0.2,3.2,0.6L37.9,4 L38.5,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st3",
    d: "M42.1,15.8h-4.5l6.4-14.2c0.4-0.9,1.3-1.4,2.2-1.3h3.3L53,15.8h-4c0,0-0.4-1.8-0.5-2.3h-3H43 C42.8,13.9,42.1,15.7,42.1,15.8L42.1,15.8z M45.9,5.9L45.9,5.9c-0.1,0.4-1.4,3.5-1.7,4.3h3.6c-0.2-0.8-1-4.4-1-4.5l-0.3-1.3 c-0.1,0.3-0.3,0.7-0.4,1S45.9,5.9,45.9,5.9L45.9,5.9L45.9,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_5",
    className: "st3",
    d: "M15.1,0.3l-4.2,10.5l-0.4-2.1C9.3,5.9,7.2,3.6,4.5,2.2l3.8,13.5l4.5,0l6.7-15.4H15.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    className: "st4",
    d: "M7,0.3H0.1L0,0.6C5.4,1.9,9,5,10.4,8.7L8.9,1.6C8.7,0.7,7.9,0.2,7,0.3"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a99b5d06555ef47dcf8f067e65c8e1a7.svg";
export { ForwardRef as ReactComponent };